import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#D80027\" d=\"M.414 15.131a12.02 12.02 0 0 0 8.456 8.456v-8.456z\"></path><path fill=\"#0052B4\" d=\"M8.87.413A12.02 12.02 0 0 0 .414 8.87H8.87z\"></path><path fill=\"#D80027\" d=\"M23.585 8.87A12.02 12.02 0 0 0 15.13.414V8.87z\"></path><path fill=\"#0052B4\" d=\"M15.129 23.587a12.02 12.02 0 0 0 8.456-8.456H15.13z\"></path><path fill=\"#496E2D\" d=\"M15.132 12a3.13 3.13 0 1 1-6.26 0c0-1.73 3.13-3.13 3.13-3.13s3.13 1.4 3.13 3.13\"></path><path fill=\"#0052B4\" d=\"M8.871 12a3.13 3.13 0 0 1 6.261 0\"></path><path fill=\"#D80027\" d=\"M10.238 10.435v1.956a1.76 1.76 0 1 0 3.522 0v-1.956z\"></path>", 8)
const _hoisted_10 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_10]))
}
export default { render: render }